import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '../auth/auth';
import { BrowserService } from '../services/browser.service';

export const browserFingerprintInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const browserService = inject(BrowserService);

  // Add browser fingerprint for unauthenticated users
  if (!auth.getIsLoggedIn()) {
    console.log('🔍 Interceptor: Adding fingerprint to', req.url);
    const fingerprint = browserService.getBrowserFingerprint();
    if (fingerprint) {
      const modifiedReq = req.clone({
        setParams: {
          fingerprint: fingerprint
        }
      });
      return next(modifiedReq);
    }
  }
  
  return next(req);
};
